import React, { useCallback, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";

import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Menu from "@material-ui/core/Menu";
import AddToShowcaseMenuItems from "./AddToShowcaseMenuItems";

const useStyles = makeStyles(theme => ({
  menuContainer: {
    zIndex: "1000",
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "400px",
    overflow: "hidden",
  },

  list: {
    height: "390px",
  },
}));

const AddToShowcaseMenu = ({ moduleId, showcaseItems, onAddClicked }) => {
  const classes = useStyles();

  const handleAddItems = useCallback(
    items => {
      onAddClicked(items);
      setOpenMenu(false);
    },
    [onAddClicked],
  );

  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const closeMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };

  const handleListKeyDown = event => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenu(false);
    }
  };

  return (
    <Box display="flex" justifyContent="end">
      <Button
        ref={anchorRef}
        onClick={toggleMenu}
        startIcon={<AddIcon />}
        aria-controls={openMenu ? `add-to-showcase-drop-down` : undefined}
        aria-haspopup="true"
        disableRipple
        style={{
          backgroundColor: openMenu && "rgba(0, 0, 0, 0.04)",
        }}
      >
        Add to Showcase
      </Button>
      <Menu
        open={openMenu}
        onClose={closeMenu}
        anchorEl={anchorRef.current}
        id={`add-to-showcase-drop-down`}
        onKeyDown={handleListKeyDown}
        classes={{
          paper: classes.menu,
        }}
        PopoverClasses={{
          root: classes.menuContainer,
        }}
        MenuListProps={{
          classes: {
            root: classes.list,
          },
        }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div>
          <AddToShowcaseMenuItems
            open={openMenu}
            moduleId={moduleId}
            showcaseItems={showcaseItems}
            onAddClicked={handleAddItems}
          />
        </div>
      </Menu>
    </Box>
  );
};

export default AddToShowcaseMenu;
